const zh = {
  kicker: "测试版",
  title: "现在就用 Expo Go 玩 Trollfossjakten。",
  lead: "我们正在测试应用并敲定合作协议。完整版应用将于 2027 年 2 月 1 日前在 App Store 和 Google Play 上线。在此之前，你可以免费试玩测试版。",
  notice: "测试版——上线前内容可能会有变动",
  step1: "安装 Expo Go",
  step1Body: "Expo Go 是一款免费应用，可运行我们的测试版。请从应用商店下载。",
  step2: "扫描二维码",
  step2Body: "iPhone：用相机应用扫描二维码。Android：打开 Expo Go，点击“Scan QR code”。",
  step3: "或在手机上打开链接",
  step3Body: "已经安装了 Expo Go？在手机上点击按钮即可直接打开测试版。",
  open: "在 Expo Go 中打开",
  copyLink: "复制链接",
  copied: "链接已复制",
  qrAlt: "Trollfossjakten 测试版应用二维码",
  dlTitle: "下载测试版",
  dlExpo: "1 · 获取 Expo Go（免费）",
  dlOpen: "2 · 打开我们的测试应用",
  dlLink: "直接链接",
  qrCaption: "扫码打开测试版",
};

export default zh;
